import React from 'react';

import Link from 'ui/Link';

import 'css/ui/Footer.css';
import twitterLogo from 'imgs/twitter-logo.svg';
import codepenLogo from 'imgs/codepen-logo.svg';
import githubLogo from 'imgs/github-logo.svg';
import paypalLogo from 'imgs/paypal-logo.svg';



class Footer extends React.PureComponent {

	render() {
		return (
			<footer className="app-footer">
				<Link
					to="https://twitter.com/cmiller__"
					external
					customStyle
					className="app-footer__link"
				>
					<img src={twitterLogo} width="32" height="32" alt="Twitter" />
				</Link>

				<Link
					to="https://codepen.io/MillerTime/"
					external
					customStyle
					className="app-footer__link"
				>
					<img src={codepenLogo} width="32" height="32" alt="CodePen" />
				</Link>

				<Link
					to="https://github.com/MilllerTime/"
					external
					customStyle
					className="app-footer__link"
				>
					<img src={githubLogo} width="32" height="32" alt="GitHub" />
				</Link>

				<Link
					to="https://paypal.me/cmiller55"
					external
					customStyle
					className="app-footer__link"
				>
					<img src={paypalLogo} width="32" height="32" alt="PayPal" />
				</Link>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/ui/Footer.jsx